export default __webpack_public_path__ + "static/media/dashboard-icon.07716b70.svg";